<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Data de Criação', 'Mensagem fora do horário', 'Mensagem de boas vindas', 'Mensagem de assumir', 'Mensagem de transferir', 'Mensagem de finalizar','Mensagem de Nps']"
            :showNew="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Edit="onEdit"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn  :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.dataInicial ? formatData(obj) : ''"  />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.mensagemForaHorario ? obj.mensagemForaHorario : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.mensagemBoasVindas ? obj.mensagemBoasVindas : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.mensagemAssumir ? obj.mensagemAssumir : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.mensagemTransferir ? obj.mensagemTransferir : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.mensagemFinalizar ? obj.mensagemFinalizar : ''" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1"  :value="obj.mensagemNps ? obj.mensagemNps : ''" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-smx" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'">
          <i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import MensagensAutomaticasRepository from '@/shared/http/repositories/configurations/mensagensautomaticas.js'

export default {
  name: 'MensagensAutomaticasList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      MensagensAutomaticasRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(this.onResultGrid)
        .catch(this.onException)
    },
    formatData (obj) {
      console.log(obj)
      return this.moment(new Date(obj.dataInicial)).tz('UTC').format('DD/MM/YYYY')
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      MensagensAutomaticasRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/mensagensautomaticas/components/list/mensagensautomaticaConfigList.vue